import { render, staticRenderFns } from "./RecepcionBuscarTarimaComponent.vue?vue&type=template&id=5e19f84e&"
import script from "./RecepcionBuscarTarimaComponent.vue?vue&type=script&lang=js&"
export * from "./RecepcionBuscarTarimaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports